import { render, staticRenderFns } from "./ScrollDownArrow.vue?vue&type=template&id=05fd5b0e&scoped=true&lang=pug"
import script from "./ScrollDownArrow.vue?vue&type=script&lang=js"
export * from "./ScrollDownArrow.vue?vue&type=script&lang=js"
import style0 from "./ScrollDownArrow.vue?vue&type=style&index=0&id=05fd5b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fd5b0e",
  null
  
)

export default component.exports